jQuery(document).ready(function ($) {

    $('.make-it-your-slider .wrapper .slider-wrapper .slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
        autoplaySpeed: 5000,
        infinite: true,
        autoplay: false,
        centerMode: true,
        centerPadding: "0",
    prevArrow: $('.make-it-your-slider .slider-prev'),
    nextArrow: $('.make-it-your-slider .slider-next'),
    responsive: [
        {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
        },
    ]
    });

    $('.hero-slider .slider-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800
    });
        
    /* ========= Logo Slider  = ========= */
    $('.featured-in .wrapper').slick({
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        draggable: false,
        pauseOnFocus: false,
        pauseOnHover: false
    });


     $('.collections-slider .slider-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        variableWidth: true,
        infinite: true,
        draggable: false,
        pauseOnFocus: false,
        pauseOnHover: false,

        prevArrow: $('.collection-prev'),
        nextArrow: $('.collection-next'),


    })

    jQuery(function ($) {

        var $slider = $('.from-flower-to-product .slider-wrapper');
        var GUTTER = 40;

        function getMaxIndex(slick) {
            if (!slick.options.variableWidth) {
                return Math.max(0, slick.slideCount - 1);
            }

            var available = slick.$list.width() - GUTTER;
            var $slides = slick.$slides;
            var total = 0;

            for (var i = $slides.length - 1; i >= 0; i--) {
                total += $slides.eq(i).outerWidth(true);
                if (total > available) {
                    return Math.min(i + 1, $slides.length - 1);
                }
            }
            return 0;
        }

        function patchSlick(slick) {
            var origGetLeft = slick.getLeft;
            var origCheckNavigable = slick.checkNavigable;
            var origGetDotCount = slick.getDotCount;

            slick.getDotCount = function () {
                return this.options.variableWidth
                    ? getMaxIndex(this)
                    : origGetDotCount.call(this);
            };

            slick.checkNavigable = function (index) {
                var result = origCheckNavigable.call(this, index);
                return this.options.variableWidth
                    ? Math.min(result, getMaxIndex(this))
                    : result;
            };

            slick.getLeft = function (slideIndex) {
                if (this.options.variableWidth) {
                    var max = getMaxIndex(this);

                    if (max === 0) return 0;

                    if (slideIndex >= max) {
                        var last = this.$slides.last()[0];
                        var end = last.offsetLeft + $(last).outerWidth(true);
                        return -Math.max(0, end - this.$list.width() + GUTTER);
                    }
                }
                return origGetLeft.call(this, slideIndex);
            };
        }

        function syncUI(slick) {
            if (slick.$dots) {
                slick.$dots.remove();
                slick.$dots = null;
            }

            slick.buildDots();

            if (slick.$dots) {
                slick.$dots.find('li').each(function (i) {
                    $(this).off('click.custom').on('click.custom', function (e) {
                        e.preventDefault();
                        $(slick.$slider).slick('slickGoTo', i);
                    });
                });
            }

            slick.updateDots();

            $(slick.$slider)
                .closest('.slider-block')
                .toggleClass('no-scroll', getMaxIndex(slick) === 0);
        }

        $slider.on('init', function (e, slick) {
            patchSlick(slick);
            syncUI(slick);
        });

        $slider.on('reInit', function (e, slick) {
            setTimeout(function () { syncUI(slick); }, 0);
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            dots: true,
            arrows: false,
            variableWidth: true,
            infinite: false
        });

        var resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                var slick = $slider.slick('getSlick');
                var max = getMaxIndex(slick);

                syncUI(slick);

                if (slick.currentSlide > max) {
                    $slider.slick('slickGoTo', max, true);
                } else {
                    slick.setPosition();
                }
            }, 250);
        });

    });


   $('.image-gallery .images-wrapper').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,

        slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


function initYouMayAlsoLikeSlider() {
    var slider = $('.you-may-also-like .you-may-also-like__grid');

    if ($(window).width() < 1200) {
        if (!slider.hasClass('slick-initialized')) {
            slider.slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 3000,
                variableWidth: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            });
        }
    } else {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');
        }
    }
}

$(document).ready(function () {
    initYouMayAlsoLikeSlider();

    $(window).on('resize', function () {
        initYouMayAlsoLikeSlider();
    });
});



$('.image-gallery .images-wrapper').magnificPopup({
    delegate: '.image-item a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1]
    },
    image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: 'title'
    }
});


$('.video-play').magnificPopup({
  type: 'inline',
  mainClass: 'mfp-fade',
  removalDelay: 200,
  callbacks: {
    open: function () {
      var v = this.content.find('video').get(0);
      if (v) v.play();
    },
    close: function () {
      var v = this.content.find('video').get(0);
      if (v) { v.pause(); v.currentTime = 0; }
    }
  }
});

    /* ========= accordian js ========= */
    // Click functionality
    $('.faqs-section .question-block').click(function () {
        $('.answer-block').slideUp();
        $('.faq-item').removeClass('active');

        if ($(this).parents('.faq-item').find('.answer-block').is(":visible")) {
        $(this).parents('.faq-item').find('.answer-block').slideUp();
        $(this).parents('.faq-item').removeClass('active');
        } else {
        $(this).parents('.faq-item').find('.answer-block').slideDown();
        $(this).parents('.faq-item').addClass('active');
        }
    });


  if (window.matchMedia("(min-width: 1200px)").matches) {
        $(".shop-by-purpose-section .card-block,.good-place-to-begin .card-block").hover(function () {
            $(this).find(".hidden-block").stop().animate(
                {
                    height: "toggle",
                    opacity: "toggle"
                },
                800
            );
        });
    }


    var $slider = $('.products-slider .slider-wrapper');
    var GUTTER = 40; 

    function getMaxIndex(slick) {
        if (!slick.options.variableWidth) {
            return Math.max(0, slick.slideCount - 1);
        }

        var available = slick.$list.width() - GUTTER;
        var $slides = slick.$slides;
        var total = 0;

        for (var i = $slides.length - 1; i >= 0; i--) {
            total += $slides.eq(i).outerWidth(true);
            if (total > available) {
                return Math.min(i + 1, $slides.length - 1);
            }
        }
        return 0; 
    }

    function patchSlick(slick) {
        var origGetLeft = slick.getLeft;
        var origCheckNavigable = slick.checkNavigable;
        var origGetDotCount = slick.getDotCount;

        slick.getDotCount = function () {
            return this.options.variableWidth
                ? getMaxIndex(this)
                : origGetDotCount.call(this);
        };

        slick.checkNavigable = function (index) {
            var result = origCheckNavigable.call(this, index);
            return this.options.variableWidth
                ? Math.min(result, getMaxIndex(this))
                : result;
        };

        slick.getLeft = function (slideIndex) {
            if (this.options.variableWidth) {
                var max = getMaxIndex(this);

                if (max === 0) return 0;

                if (slideIndex >= max) {
                    var last = this.$slides.last()[0];
                    var end = last.offsetLeft + $(last).outerWidth(true);
                    return -Math.max(0, end - this.$list.width() + GUTTER);
                }
            }
            return origGetLeft.call(this, slideIndex);
        };
    }

    function syncUI(slick) {
        if (slick.$dots) {
            slick.$dots.remove();
            slick.$dots = null;
        }

        slick.buildDots();

        if (slick.$dots) {
            slick.$dots.find('li').each(function (i) {
                $(this).off('click.custom').on('click.custom', function (e) {
                    e.preventDefault();
                    $(slick.$slider).slick('slickGoTo', i);
                });
            });
        }

        slick.updateDots();

        $(slick.$slider)
            .closest('.slider-block')
            .toggleClass('no-scroll', getMaxIndex(slick) === 0);
    }

    $slider.on('init', function (e, slick) {
        patchSlick(slick);
        syncUI(slick);
    });

    $slider.on('reInit', function (e, slick) {
        setTimeout(function () { syncUI(slick); }, 0);
    });

    $slider.slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                }
            }
        ]
    });

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            var slick = $slider.slick('getSlick');
            var max = getMaxIndex(slick);

            syncUI(slick);

            if (slick.currentSlide > max) {
                $slider.slick('slickGoTo', max, true);
            } else {
                slick.setPosition();
            }
        }, 250);
    });

    $('.product-thumbnail-images .wrapper').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        dots: false,
        infinite: false,
        focusOnSelect: true,
        asNavFor: '.product-main-images .wrapper',
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 576,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 4
                }
            }
        ]
    });

    $('.product-main-images .wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        asNavFor: '.product-thumbnail-images .wrapper',
        adaptiveHeight: false,
        fade: false
    });

    /* ========= accordian js ========= */

    // Click functionality
    $('.product-accordion-title').click(function () {
        $('.product-accordion-description').slideUp();
        $('.product-accordion-item').removeClass('active');

        if ($(this).parents('.product-accordion-item').find('.product-accordion-description').is(":visible")) {
        $(this).parents('.product-accordion-item').find('.product-accordion-description').slideUp();
        $(this).parents('.product-accordion-item').removeClass('active');
        } else {
        $(this).parents('.product-accordion-item').find('.product-accordion-description').slideDown();
        $(this).parents('.product-accordion-item').addClass('active');
        }
    });

    (function ($) {
        function initRelatedProducts() {
            $('product-recommendations .product-grid').each(function () {
            var $slider = $(this);

            // Skip if Slick is already initialized
            if ($slider.hasClass('slick-initialized')) {
                return;
            }

            // Wait until product cards are available
            if (!$slider.children('.grid__item').length) {
                return;
            }

            $slider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                adaptiveHeight: false,
                prevArrow: $('.related-prev'),
                nextArrow: $('.related-next'),
                responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                    slidesToShow: 3
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                    slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 1
                    }
                }
                ]
            });
            });
        }

        function observeRelatedProducts() {
            document.querySelectorAll('product-recommendations').forEach(function (section) {
            if (section.dataset.slickObserverAttached) {
                return;
            }

            section.dataset.slickObserverAttached = 'true';

            var observer = new MutationObserver(function () {
                initRelatedProducts();
            });

            observer.observe(section, {
                childList: true,
                subtree: true
            });

            initRelatedProducts();
            });
        }

        $(document).ready(function () {
            observeRelatedProducts();
        });

        document.addEventListener('shopify:section:load', function () {
            observeRelatedProducts();
        });
    })(jQuery);

});
$(document).ready(function () {

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const ritualMediaQuery = window.matchMedia('(max-width: 889px)');
    const kallaMediaQuery = window.matchMedia('(max-width: 989px)');


    // =========================================
    // Common Slick Toggle Function
    // =========================================
    function toggleSlick($slider, options, e) {

        if (!$slider.length) return;

        if (e.matches) {

            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick(options);
            }

        } else {

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            // Cleanup leftover slick classes / inline styles / clones
            // (desktop par slider jevu layout na rahe te mate)
            $slider.removeClass('slick-initialized slick-slider slick-dotted');
            $slider.removeAttr('style');
            $slider.find('.slick-cloned').remove();
            $slider.find('.slick-list, .slick-track').contents().unwrap();
            $slider.children('.slick-arrow, .slick-dots').remove();
            $slider.children().each(function () {
                $(this)
                    .removeClass('slick-slide slick-current slick-active slick-center')
                    .removeAttr('style')
                    .removeAttr('tabindex')
                    .removeAttr('role')
                    .removeAttr('aria-hidden')
                    .removeAttr('aria-describedby')
                    .removeAttr('data-slick-index');
            });
        }
    }


    // =========================================
    // Product Features
    // 767px and below = 1 slide
    // =========================================
    const productFeaturesSlider = {

        $el: $('.product-features .wrapper'),

        options: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,

            prevArrow: `
                <button type="button" class="slick-prev" aria-label="Previous">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M15 18L9 12L15 6"
                            stroke="#9E1C1F"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            `,

            nextArrow: `
                <button type="button" class="slick-next" aria-label="Next">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#9E1C1F"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            `
        }
    };


    // =========================================
    // Shop By Ritual
    //
    // 890px+       = Normal layout
    // 768px–889px  = 2 slides
    // 0px–767px    = 1 slide
    // =========================================
    const ritualSlider = {

        $el: $('.shop-by-ritual .wrapper'),

        options: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,

            responsive: [
                {
                    breakpoint: 768,

                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    };


    // =========================================
    // How Kalla Made
    // =========================================
    const kallaSlider = {

        $el: $('.how-kalla-made-section .box-wrapper .wrapper'),

        options: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,

            responsive: [
                {
                    breakpoint: 575,

                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    };


    // =========================================
    // Handlers
    // =========================================

    function handleProductFeatures(e) {

        toggleSlick(
            productFeaturesSlider.$el,
            productFeaturesSlider.options,
            e
        );

    }


    function handleRitual(e) {

        toggleSlick(
            ritualSlider.$el,
            ritualSlider.options,
            e
        );

    }


    function handleKalla(e) {

        toggleSlick(
            kallaSlider.$el,
            kallaSlider.options,
            e
        );

    }


    // =========================================
    // Initial Check
    // =========================================

    handleProductFeatures(mediaQuery);

    handleRitual(ritualMediaQuery);

    handleKalla(kallaMediaQuery);


    // =========================================
    // Breakpoint Change
    // =========================================

    mediaQuery.addEventListener(
        'change',
        handleProductFeatures
    );

    ritualMediaQuery.addEventListener(
        'change',
        handleRitual
    );

    kallaMediaQuery.addEventListener(
        'change',
        handleKalla
    );


    var resizeTimer;

    $(window).on('resize orientationchange', function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
            handleProductFeatures(mediaQuery);
            handleRitual(ritualMediaQuery);
            handleKalla(kallaMediaQuery);
        }, 150);
    });

    $('.footer .footer-block--menu .footer-block__heading').on('click', function () {

        if ($(window).width() > 768) return;

        var $heading = $(this);
        var $content = $heading.next('.footer-block__details-content');

        // Close other menus
        $('.footer .footer-block--menu .footer-block__heading')
        .not($heading)
        .removeClass('active')
        .attr('aria-expanded', 'false')
        .next('.footer-block__details-content')
        .stop(true, true)
        .slideUp(300);

        // Toggle clicked menu
        $heading.toggleClass('active');

        var isOpen = $heading.hasClass('active');

        $heading.attr('aria-expanded', isOpen ? 'true' : 'false');

        $content.stop(true, true).slideToggle(300);
    });

    // First item open by default

    $('.reasons-wrapper .question-block').on('click', function () {

        var $item = $(this).closest('.reason-item');
        var $answer = $item.find('.answer-block');

        // Close other items
        $('.reasons-wrapper .reason-item').not($item).removeClass('active');
        $('.reasons-wrapper .answer-block').not($answer).stop(true, true).slideUp(300);

        // Toggle current item
        if ($item.hasClass('active')) {

            $item.removeClass('active');
            $answer.stop(true, true).slideUp(300);

        } else {

            $item.addClass('active');
            $answer.stop(true, true).slideDown(300);

        }

    });

     // First item open by default

        var faqItems = jQuery('.faqs-wrapper .faq-item');

            // Badha FAQ close
            faqItems.removeClass('active');
            faqItems.find('.content-boxes').hide();

            // FAQ title click
            jQuery('.faqs-wrapper .faq-block').on('click', function () {

                var currentItem = jQuery(this).closest('.faq-item');
                var currentContent = currentItem.find('.content-boxes');

                if (currentItem.hasClass('active')) {
                    // Active FAQ ne close na karvo hoy to aa block remove kari shakay
                    currentContent.stop(true, true).slideUp(300);
                    currentItem.removeClass('active');

                } else {
                    faqItems.removeClass('active');
                    faqItems.find('.content-boxes').stop(true, true).slideUp(300);

                    currentItem.addClass('active');
                    currentContent.stop(true, true).slideDown(300);
                }

            });




});